import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { OrganizationSubscriptionModel } from './organization-subscription.model';

@Injectable()
export class OrganizationSubscriptionService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetSubscriptionListByOrganizationHashId(organizationHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getSubscriptionListForOrganization = WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?" + queryString + "&organizationHashId=" + organizationHashId;
    }
    else {
      getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?organizationHashId=" + organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSubscriptionListForOrganization, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionListByOrganizationToInstance(organizationHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getSubscriptionListForOrganization = WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION_TO_INSTANCE;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?" + queryString + "&organizationHashId=" + organizationHashId;
    }
    else {
      getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?organizationHashId=" + organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSubscriptionListForOrganization, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AssignSubscriptionToOrganization(organizationSubscriptionModel: OrganizationSubscriptionModel): Observable<IAPIResponse> {
    let body = organizationSubscriptionModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_ORGANIZATION_SUBSCRIPTION_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSubscriptionList(organizationHashId: string, input?: DataListModel): any {
    input.currentPage = 0;
    let getSubscriptionUrl = WeGoConfig.API_EXPORT_ORGANIZATION_SUBSCRIPTION_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSubscriptionUrl = getSubscriptionUrl + "?" + queryString + "&organizationHashId=" + organizationHashId;
    }
    else {
      getSubscriptionUrl = getSubscriptionUrl + "?organizationHashId=" + organizationHashId;
    }

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSubscriptionUrl, options);
  }

  public DeleteSubscriptionMapping(subscriptionMapHashId: string): Observable<IAPIResponse> {
    let getSubscriptionToOrganizationUrl = WeGoConfig.API_DELETE_ORGANIZATION_SUBSCRIPTION_MAPPING + "?subscriptionMapHashId=" + subscriptionMapHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(getSubscriptionToOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationsubscription/models/organization-subscription.service.ts